export default {
  QUEST_HELP_QUESTID: 'c-greta-help-hub',
  USER_ID: 'u-6edab64c-9d82-4840-b946-ca793e44dfba',
  APIKEY: 'k-c43730eb-d404-42ba-bb54-c49b1656cf67',
  TOKEN: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ1c2VySWQiOiJ1LTZlZGFiNjRjLTlkODItNDg0MC1iOTQ2LWNhNzkzZTQ0ZGZiYSIsImlhdCI6MTc1MTkxMzM3MCwiZXhwIjoxNzU0NTA1MzcwfQ.QNQWzph_BDsgp8B6jHCr9in8A1tWFnrHmxLxYQHiYYg',
  ENTITYID: 'e-36943888-5505-48cf-bbde-b5f89d924337',
  PRIMARY_COLOR: '#0080ff' // Updated to match logo blue
};